import * as React from 'react';
import TablePagination from '@mui/material/TablePagination';
import PropTypes from 'prop-types';

const propTypes = {
	count: PropTypes.number,
	page: PropTypes.number,
	disabled: PropTypes.bool,
	color: PropTypes.string,
	variant: PropTypes.oneOf(['outlined', 'text']),
	shape: PropTypes.oneOf(['circular', 'rounded']),
	size: PropTypes.oneOf(['small', 'medium', 'large']),
	showFirstButton: PropTypes.bool,
	showLastButton: PropTypes.bool,
	hidePrevButton: PropTypes.bool,
	hideNextButton: PropTypes.bool,
	onChange: PropTypes.func,
	onPageChange: PropTypes.func,
	rowsPerPage: PropTypes.number,
	onRowsPerPageChange: PropTypes.func,
};

const defaultProps = {
	count: 0,
	disabled: false,
	variant: 'text',
	shape: 'circular',
	size: 'medium',
	color: 'primary',
	showFirstButton: true,
	showLastButton: true,
	hidePrevButton: false,
	hideNextButton: false,
	onChange: () => {},
	page: 0,
	onPageChange: () => {},
	rowsPerPage: 0,
	onRowsPerPageChange: () => {},
	rowsPerPageOptions: [200, 300, 400, 500],
};

const MimaPagination = ({ ...props }) => {
	return (
		<div>
			<TablePagination
				{...props}
				component="div"
				backIconButtonProps={{
					'aria-label': 'Previous Page',
				}}
				nextIconButtonProps={{
					'aria-label': 'Next Page',
				}}
			/>
		</div>
	);
};

MimaPagination.propTypes = propTypes;

MimaPagination.defaultProps = defaultProps;

export default MimaPagination;
